export enum FirearmType {
  Pistol = 'Handgun (Pistol or Revolver)',
  Rifle = 'Long Gun (Rifle or Shotgun)',
  SBR = 'Other Firearms (Frame, Receiver, etc)',
  MultipleFirearmTypes='Multiple Firearm Types',
  NFASuppressor = 'NFA Item',
}

export const Firearms = [
  { value: 'SBR', type: FirearmType.SBR },
  { value: 'Rifle', type: FirearmType.Rifle },
  { value: 'Pistol', type: FirearmType.Pistol },
  { value: 'MultipleFirearmTypes', type: FirearmType.MultipleFirearmTypes },
  { value: 'NFASuppressor', type: FirearmType.NFASuppressor },
]

